import {
  useHits,
  useStats,
  useClearRefinements,
  type UseClearRefinementsProps,
  type UseHitsProps,
} from 'react-instantsearch';
import {Stockist} from '../../types';
import {FilterDropdown} from './FilterDropdown.client';
import {StockistCard} from './StockistCard.client';
import {useSiteContext} from '../../hooks/useSiteContext';
import clsx from 'clsx';

type StockistsListProps = {
  isMapBlock?: boolean;
};

export const StockistsList = (props: StockistsListProps) => {
  return (
    <div className="h-full  w-full overflow-y-hidden pt-5">
      <div
        className={clsx('flex w-full items-center justify-between', {
          'px-5 lg:px-13': props.isMapBlock,
        })}
      >
        <CustomStats />
        <div className="flex items-center gap-x-5">
          <CustomClearRefinements />
          <FilterDropdown attribute="storeBrand" limit={100} />
        </div>
      </div>
      <CustomHits isMapBlock={props.isMapBlock} />
    </div>
  );
};

const CustomHits = (props: UseHitsProps<Stockist> & {isMapBlock?: boolean}) => {
  const {state} = useSiteContext();
  const geoFenceCode = state?.geoFenceCode;

  const {hits} = useHits(props);

  const nzHits = hits.filter((hit) => hit.countryCode === 'NZ');
  const auHits = hits.filter((hit) => hit.countryCode === 'AU');

  return (
    <div
      className={clsx([
        'mt-2 flex flex-col overflow-y-scroll',
        props.isMapBlock
          ? 'mr-5 h-[400px] max-h-full lg:mr-13 lg:h-[600px]'
          : 'h-full max-h-[calc(100dvh-300px)] lg:max-h-[50vh] lg:min-h-[50vh]',
      ])}
      id="stockistsList"
    >
      <div
        className={clsx([geoFenceCode === 'NZ' ? 'order-first' : 'order-last'])}
      >
        {nzHits.map((hit: Stockist) => (
          <StockistCard
            objectID={hit.objectID}
            storeName={hit.storeName}
            address={hit.address}
            countryCode={hit.countryCode}
            phone={hit.phone}
            key={hit.objectID}
            _geoloc={hit._geoloc}
            isMapBlock={props.isMapBlock}
            storeBrand={hit.storeBrand}
            logoUrl={hit.logoUrl}
          />
        ))}
      </div>
      <div>
        {auHits.map((hit: Stockist) => (
          <StockistCard
            objectID={hit.objectID}
            storeName={hit.storeName}
            address={hit.address}
            countryCode={hit.countryCode}
            phone={hit.phone}
            key={hit.objectID}
            _geoloc={hit._geoloc}
            isMapBlock={props.isMapBlock}
            storeBrand={hit.storeBrand}
            logoUrl={hit.logoUrl}
          />
        ))}
      </div>
    </div>
  );
};

const CustomStats = () => {
  const {nbHits} = useStats();

  const resultText = nbHits === 1 ? 'result' : 'results';

  return (
    <p className="richH7">
      Showing{' '}
      <span className="font-semibold">
        {nbHits} {resultText}
      </span>
    </p>
  );
};

const CustomClearRefinements = (props: UseClearRefinementsProps) => {
  const {canRefine, refine} = useClearRefinements(props);

  return (
    <button
      className={clsx(['richH7 ', !canRefine && 'hidden'])}
      disabled={!canRefine}
      onClick={() => refine()}
    >
      X Clear filter
    </button>
  );
};
